export enum OrderStatus {
    OPEN = 'OPEN', 
    PENDING_PAYMENT = 'PENDING_PAYMENT', 
    PAID = 'PAID', 
    WAITING_PAYMENT_VERIFICATION = 'WAITING_PAYMENT_VERIFICATION', 
    EXPIRED = 'CANCELLED', 
    CANCELLED = 'CANCELLED', 
    REJECTED = 'REJECTED'
}